// ---------------------------------------------------------

export { default } from './component';
